<template>
  <el-dialog
    :title="props.title || '物流轨迹'"
    :visible.sync="visible"
    width="1000px"
    :confirm-loading="confirmLoading"
    @close="close"
  >
    <div style="flex: 1; align-items: center; justify-content: center; display: flex">
      <div v-if="orders && orders.length > 0" style="flex: 1">
        <el-tabs v-model="activeTabName" type="border-card" style="width: 960px ;margin-bottom: 8px" @tab-click="handleTabClick">
          <el-tab-pane :label="i.tabName" v-for="(i, index) in orders" :name="'' + index" :key="index">
            <div v-loading="i.loading">
              <el-row :gutter="24" style="width: 100%">
                <el-col v-if="i.driverName" :span="6">司机: {{ i.driverName || '-' }}</el-col>
                <el-col v-if="i.driverPhone" :span="6">联系电话: {{ i.driverPhone || '-' }}</el-col>
                <el-col :span="8">订单号: <span class="green-text">{{ i.orderNo || '-' }}</span></el-col>
                <el-col :span="4">食材种类: <span class="green-text">{{ i.itemCount || '-' }}</span></el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div style="height: 450px; width: 100%; display: flex; align-items: center; justify-content: center">
          <iframe
            ref="iframe"
            v-if="iframeShow && url"
            :src="url"
            height="450px"
            width="100%"
            style="border: 0; flex: 1"
          />
          <div style="text-align: center" v-else>
            <empty style="width: 150px" />
              暂无轨迹
          </div>
        </div>
      </div>
      <div v-else style="text-align: center">
        <empty />
        暂无物流信息
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Empty from "@/components/Empty.vue";

export default {
  name: 'RouterTrackDialog',
  components: {Empty},
  data() {
    return {
      confirmLoading: false,
      visible: false,
      props: {},
      orders: [],
      url: '',
      activeTabName: null,
      iframeShow: true
    }
  },
  methods: {
    open(props = {}) {
      this.props = props || {}
      this.visible = true
      this.$nextTick(() => {
        const {orders} = this.props || {}
        this.orders = (orders || []).map((item, index) => {
          return {
            tabName: `订单${index + 1}`,
            orderNo: item.orderNo,
            tenantId: item.tenantId,
            type: item.type,
            driverName: '',
            driverPhone: '',
            itemCount: 0,
            loading: false
          }
        })
        if (this.orders.length > 0) {
          this.activeTabName = '0'
          this.fetchInfo(this.orders[0])
        } else {
          this.activeTabName = null
        }
      })
    },
    async fetchInfo(item) {
      // 抓取信息
      item.loading = true
      this.$axios.post(
        `/api-r/vobc/router/track/` + item.type,
        this.$qs.stringify({orderNo: item.orderNo, tenantId: item.tenantId}),
        {headers: {accessToken: JSON.parse(sessionStorage.getItem("userdata")).token}}
      ).then((res) => {
        if (res.data.success) {
          const { order } = res.data || {}
          item.driverName = order && order.driverName
          item.driverPhone = order && order.driverPhone
          item.itemCount = order && order.itemCount
          this.url = res.data.routerTrackUrl
          this.iframeShow = false
          requestAnimationFrame(() => {
            this.iframeShow = true
          })
        }
      }).catch(() => {
        this.iframeShow = false
      }).finally(() => {
        item.loading = false
      });
    },
    handleTabClick(val) {
      this.fetchInfo(this.orders[parseInt(val.name)])
    },
    close() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.green-text {
  color: #13A25E;
}
</style>
